import styled from 'styled-components';

export const WrapHolidayBannerStyled = styled.div`
  .Polaris-Banner > .Polaris-Box > .Polaris-BlockStack .Polaris-Box:first-child {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
`;
